import { extendTheme } from '@mui/joy/styles';
import { ColorSchemes } from './ColorSchemes';
import { JoyAutocompleteConfig } from './Components/JoyAutocompleteConfig';
import { JoyButtonConfig } from './Components/JoyButtonConfig';
import { JoyCheckboxConfig } from './Components/JoyCheckboxConfig';
import { JoyIconButtonConfig } from './Components/JoyIconButtonConfig';
import { JoyInputConfig } from './Components/JoyInputConfig';
import { JoyMenuItemConfig } from './Components/JoyMenuItemConfig';
import { JoyModalConfig } from './Components/JoyModalConfig';
import { JoyProgressConfig } from './Components/JoyProgressConfig';
import { JoyRadioConfig } from './Components/JoyRadioConfig';
import { JoySelectConfig } from './Components/JoySelectConfig';
import { JoyTextAreaConfig } from './Components/JoyTextAreaConfig';
import { Typography } from './Typography';

declare module '@mui/joy/styles' {
  // No custom tokens found, you can skip the theme augmentation.
}

export const theme = extendTheme({
  ...Typography,
  colorSchemes: ColorSchemes,
  components: {
    ...JoyButtonConfig,
    ...JoyIconButtonConfig,
    ...JoyMenuItemConfig,
    ...JoyInputConfig,
    ...JoyTextAreaConfig,
    ...JoyModalConfig,
    ...JoyProgressConfig,
    ...JoySelectConfig,
    ...JoyAutocompleteConfig,
    ...JoyCheckboxConfig,
    ...JoyRadioConfig,
  },
});
